import { Box, FormHelperText, InputLabel, TextField } from "@mui/material";
import customInputStyles from "./CustomInput.styles";

interface CustomProps {
  label?: any;
  placeHolder?: string;
  value?: string | number;
  onChange?: any;
  type?: string;
  name?: any;
  select?: boolean;
  onKeyPress?: any;
  InputProps?: any;
  error?: any;
  required?: boolean;
  InputLabelProps?: any;
  id?: string;
  sx?: any;
  propsToInputElement?: any;
  disabled?: boolean;
  onBlur?: Function;
  multiline?: boolean;
  ref?: any;
  onInput?: Function;
}

const CustomInput = (props: CustomProps) => {
  const classes = customInputStyles;
  const { error } = props;

  return (
    <Box>
      <Box mb={props.label ? 1 : 0}>
        <InputLabel required={props.required} sx={classes.nameField}>
          {props.label}
        </InputLabel>
      </Box>
      <TextField
        sx={
          props.sx ? { ...classes.textField, ...props.sx } : classes.textField
        }
        variant="outlined"
        ref={props.ref}
        id={props.id}
        placeholder={props.placeHolder}
        type={props.type}
        name={props.name}
        select={props.select}
        value={props.value}
        multiline={props.multiline}
        maxRows={6}
        InputProps={props.InputProps}
        inputProps={props.propsToInputElement}
        onChange={props.onChange}
        onInput={props.onInput}
        onKeyPress={props.onKeyPress}
        required={props.required}
        onBlur={props.onBlur}
        {...(error && { error: true, helperText: "" })}
        disabled={props.disabled}
      />
      {error && (
        <FormHelperText sx={classes.errorStyle}>{error}</FormHelperText>
      )}
    </Box>
  );
};

export default CustomInput;
